export const getHoustonUrl = (pageType: string, isProduction: boolean): string | null =>
  isProduction ? `/500.ashx?source=travel-tools&prevPageGroup=${pageType}` : null;
